const unexpectedFiled = filed => `${filed} is unexpcted`;
module.exports = {
  unexpectedFiled,
};
